import {type FC, useCallback} from 'react';
import './alert-component.scss';
import {useAlert} from '../../provider/alert/userAlert';


export const SUCCESS = 'success';
export const ERROR = 'error';

export type AlertType = typeof SUCCESS | typeof ERROR;

export interface AlertMessage {
    text?: string,
    type?: AlertType;
    setAlert: (type: AlertType | undefined, text: string | undefined) => void;
}

const AlertComponent: FC = () => {
    const {text, type, setAlert} = useAlert();

    const closeAlert = useCallback(
        () => {
            setAlert(undefined, undefined);
        },
        [setAlert],
    );

    if (!text && !type) {
        return <></>;
    }

    return (
       <div
          className={`alert ${type === SUCCESS ? 'alert-success' : 'alert-danger'} alert-dismissible fade show alert-component`}
          role="alert"
       >
           {text}
           <button
              type="button"
              className="btn-close"
              data-bs-dismiss="alert"
              aria-label="Close"
              onClick={closeAlert}
           ></button>
       </div>
    );
};

export default AlertComponent;
